import Service from './Service';

class BiztDokService extends Service {
    getDocuments(biztositok, kockKezd, modozat) {
        return this.get('allDoc?', {
            biztosito: 11,
            kock_kezd: kockKezd,
            modozat,
        });
    }

    procGetDocuments(biztositok, modozat, kockKezd, dokumentumTipusok, dokumentumCode) {
        return this.post('getDocuments?', {
            biztositok,
            kock_kezd: kockKezd,
            modozat,
            dokumentum_tipus: dokumentumTipusok,
            dokumentum_code: dokumentumCode,
        });
    }

    getAllBdoktipus() {
        return this.get('allBdoktipus');
    }

    // eslint-disable-next-line class-methods-use-this
    getDocById(docId) {
        window.open(`/api/biztositoiDokumentumok/biztDocument?docId=${docId}`);
    }

    getAllDocByType(doctype, codename) {
        return this.get('documentsByType?', {
            doctype,
            codename,
        });
    }
}

export default new BiztDokService('/api/biztositoiDokumentumok/');
